export const items = [
  {
    name: {
      first: 'Обзорная экскурсия по Санкт-Петербургу',
      second: ''
    },
    cost: 22500,
    dates: ['Вторник (19:00 - 22:00)', 'Четверг (19:00 - 22:00)'],
    period: 'Октябрь 2018 - Январь 2020',
    duration: '4 месяца'
  },
  {
    name: {
      first: 'Тематические экскурсии по Санкт-Петербургу',
      second: ''
    },
    cost: 22500,
    dates: ['Понедельник (19:00 - 22:00)', 'Среда (19:00 - 22:00)'],
    period: 'Февраль 2020 - Апрель 2020',
    duration: '3 месяца'
  },
  {
    name: {
      first: 'Пригороды Санкт-Петербурга',
      second: 'Петергоф, Царское Село и Павловск'
    },
    cost: 22500,
    dates: ['Вторник (19:00 - 22:00)', 'Четверг (19:00 - 22:00)'],
    period: 'Февраль 2020 - Апрель 2020',
    duration: '3 месяца'
  },
  {
    name: {
      first: 'Приморское кольцо',
      second: 'Ораниенбаум, Кронштадт, Выборг'
    },
    cost: 22500,
    dates: ['Понедельник (19:00 - 22:00)', 'Среда (19:00 - 22:00)'],
    period: 'Октябрь 2018 - Январь 2020',
    duration: '4 месяца'
  }
]

export const entryLvlCourseCost = [
  {
    paymentPeriod: '03 октября 2023 г.',
    month: 'Октябрь  2023',
    paymentMonth: '5 900 руб.'
  },
  {
    paymentPeriod: '02 ноября 2023 г.',
    month: 'Ноябрь 2023',
    paymentMonth: '5 900 руб.'
  },
  {
    paymentPeriod: '05 декабря 2023 г.',
    month: 'Декабрь 2023',
    paymentMonth: '5 900 руб.'
  },
  {
    paymentPeriod: '26 декабря 2023 г',
    month: 'Январь 2024',
    paymentMonth: '4 800 руб.'
  },
  {
    paymentPeriod: '6 февраля 2024 г. ',
    month: 'Февраль 2024',
    paymentMonth: '7 500 руб.'
  },
  {
    paymentPeriod: '5 марта 2024 г.',
    month: 'Март 2024',
    paymentMonth: '7 500 руб.'
  },
  {
    paymentPeriod: '2 апреля 2024 г.',
    month: 'Апрель 2024',
    paymentMonth: '7 500 руб.'
  }
]

export const advLvlCourseCost = [
  {
    paymentPeriod: '2 октября 2018 г.',
    month: 'Октябрь  2018',
    paymentMonth: '5 800  руб.'
  },
  {
    paymentPeriod: '6 ноября 2018 г.',
    month: 'Ноябрь 2018',
    paymentMonth: '6 700  руб.'
  },
  {
    paymentPeriod: '4 декабря 2018 г.',
    month: 'Декабрь 2018',
    paymentMonth: '6 500  руб.'
  },
  {
    paymentPeriod: '25 декабря 2018 г',
    month: 'Январь 2018 ',
    paymentMonth: '3 500  руб.'
  },
  {
    paymentPeriod: '5 февраля 2020 г. ',
    month: 'Февраль 2020',
    paymentMonth: '7 500  руб.'
  },
  {
    paymentPeriod: '5 марта 2020 г.',
    month: 'Март 2020',
    paymentMonth: '8 500  руб.'
  },
  {
    paymentPeriod: '2 апреля 2020 г.',
    month: 'Апрель 2020',
    paymentMonth: '6 500  руб.'
  }
]



// WEBPACK FOOTER //
// ./src/data/index.js